import {Page, LeftSidebar, Content, RightSidebar} from '../../layout/index.styled';
import {useBehaviorSubject, useStream} from '@esgi/ui-kit/utils';
import {useMemo, useState} from 'react';
import {StudentProgressReport as StudentProgressReportUI, useStudentProgressReport, StudentProgressReportContext} from '@esgi/main/features/teacher/student-progress-report';
import {FlexBox} from '@esgi/ui-kit/layout';
import {Divider} from './index.styled';
import {
	SubjectTab,
} from '@esgi/contracts/esgi/types/esgi.assets/endpoints/esgi.apigateway/teachers/pages/home/sections/subjects/init/subject-tab';
import {Reports} from '@esgi/main/kits/reports';
import {withNewOldReports} from '../../old-reports';
import {OldStudentProgress} from '../../old-reports/students/student-progress';

function StudentProgressReport() {
	const {service} = useStudentProgressReport();
	const valid = useStream(service.valid$, false);
	const busy = useStream(service.busy$, false);
	const classes = useBehaviorSubject(service.studentService.classes$);
	const groups = useBehaviorSubject(service.studentService.groups$);
	const students = useBehaviorSubject(service.studentService.students$);
	const selectedStudents = useBehaviorSubject(service.students$);
	const tests = useBehaviorSubject(service.testService.tests$);
	const subjects = useBehaviorSubject(service.subjectService.subjects$);
	const loaded = useBehaviorSubject(service.studentService.loaded$);
	const includeGrades = useBehaviorSubject(service.includeGrades$);
	const showBaseline = useBehaviorSubject(service.showBaseline$);
	const carryForward = useBehaviorSubject(service.carryForward$);
	const displayType = useBehaviorSubject(service.displayType$);
	const displayNotTestedType = useBehaviorSubject(service.displayNotTestedType$);
	const colorType = useBehaviorSubject(service.colorType$);
	const gradeScales = useBehaviorSubject(service.gradeScales$);
	const subjectTab = useBehaviorSubject<SubjectTab>(service.subjectTab$);
	const loadingTests = useBehaviorSubject<boolean>(service.testService.loaded$);

	const [preview, setPreview] = useState(false);
	const isDisabled = useMemo(() => {
		return !valid || busy;
	}, [valid, busy]);

	return <StudentProgressReportContext.Provider value={service}>
			<Page>
			<LeftSidebar>
				{loaded &&
					<StudentProgressReportUI.StudentsControl
						classes={classes}
						groups={groups}
						students={students}
						onChange={(value) => service.setStudents(value)}
					/>
				}
			</LeftSidebar>
			<Content>
				<FlexBox align='center'>
					<StudentProgressReportUI.StudentCounter />
					<Divider />
					<StudentProgressReportUI.SubjectTabControl selected={subjectTab} subjects={subjects} onChange={(value) => service.setSubjectTab(value)}/>
				</FlexBox>
				{selectedStudents.length
					?
					<StudentProgressReportUI.TestsControl
						skeleton={loadingTests}
						tests={tests}
						onChange={(value) => service.setSelectedTests(value)}
						allSubjectsMode={subjectTab?.id === 0}
					/>
					: <Reports.NoStudentPanel/>
				}
			</Content>
			<RightSidebar>
				<StudentProgressReportUI.DownloadPanel
					downloadTitle='Report'
					disabled={isDisabled}
					onClick={() => {
						service.generateReport();
						setPreview(true);
					}}
				/>
				<StudentProgressReportUI.DisplayTypeControl value={displayType} onChange={(value) => service.setDisplayType(value)} disabled={isDisabled} />
				<StudentProgressReportUI.SettingsControl
					disabled={isDisabled}
					showBaseline={showBaseline}
					onShowBaselineChange={(value) => service.setShowBaseline(value)}
					carryForward={carryForward}
					onCarryForwardChange={(value) => service.setCarryForward(value)}
				/>
				<StudentProgressReportUI.GradeLevelControl
					value={includeGrades}
					gradeScales={gradeScales}
					onChange={(value) => service.setIncludeGrades(value)}
					disabled={isDisabled}/>
				<StudentProgressReportUI.DisplayNotTestedControl disabled={isDisabled} value={displayNotTestedType} onChange={(value) => service.setDisplayNotTested(value)} />
				<StudentProgressReportUI.ColorSelectorControl disabled={isDisabled} value={colorType} onChange={(value) => service.setColorType(value)} />
			</RightSidebar>
		</Page>
		{preview &&
			<StudentProgressReportUI.PreviewDialog
				service={service}
				onClose={() => setPreview(false)}
			/>
		}
	</StudentProgressReportContext.Provider>;
}

export default withNewOldReports(OldStudentProgress, StudentProgressReport);